/** Koliko je dana unaprijed izmišljeni istek u primjeru plana slanja. */
const EXAMPLE_EXPIRY_IN_DAYS = 30;

export const formatScheduleDate = (date: Date) =>
  date.toLocaleDateString("hr-HR", { day: "2-digit", month: "2-digit", year: "numeric" });

/**
 * Izmišljeni datum isteka za prikaz primjera. Stvarni se zna tek kad notifikacija dobije
 * entitet, a plan slanja se treba vidjeti već pri unosu i u pretrazi.
 */
export const getExampleExpiryDate = (): Date => {
  const date = new Date();
  date.setDate(date.getDate() + EXAMPLE_EXPIRY_IN_DAYS);

  return date;
};

export interface NotificationScheduleItem {
  date: Date;
  label: string;
  variant: "info" | "success";
}

/**
 * Plan slanja za jedan istek: primarna obavijest i njena ponavljanja.
 *
 * Datum isteka se prima izvana, a ne računa unutra, da isti plan mogu prikazati i unos
 * notifikacije i tablica pretrage — svaki sa svojim primjerom.
 */
export const buildNotificationSchedule = (
  expiryDate: Date,
  daysBeforeExpiry: number | null | undefined,
  repeatIntervalDays: number | null | undefined,
  repeatCount: number | null | undefined
): NotificationScheduleItem[] => {
  if (daysBeforeExpiry == null || daysBeforeExpiry < 0) return [];

  const primaryDate = new Date(expiryDate);
  primaryDate.setDate(primaryDate.getDate() - daysBeforeExpiry);

  const items: NotificationScheduleItem[] = [
    { date: primaryDate, label: "Primarno slanje", variant: "info" },
  ];

  const interval = repeatIntervalDays ?? 0;
  const count = repeatCount ?? 0;

  if (interval > 0 && count > 0) {
    for (let i = 1; i <= count; i++) {
      const repeatDate = new Date(primaryDate);
      repeatDate.setDate(repeatDate.getDate() + i * interval);

      items.push({ date: repeatDate, label: `${i}. ponavljanje`, variant: "success" });
    }
  }

  return items;
};
